export default __webpack_public_path__ + "static/economy-d4bd9e4c391b39fb7607569a638343b2.png";